import { Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";
import { ProtectedRoute } from "./routes/ProtectedRoute";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import ChangePassword from "./pages/ChangePassword";
import WarehouseSync from "./pages/warehouseSync/WarehouseSync";
import Kassensystem from "./pages/kassensystem/Kassensystem";
import Members from "./pages/members/Members";
import FamilyInfo from "./pages/familyInfo/FamilyInfo";
import AccessRequests from "./pages/requests/AccessRequests";
import WeeklyDues from "./pages/weeklyDues/WeeklyDues";
import UsersHub from "./pages/users/UsersHub";
import UserActivity from "./pages/activity/UserActivity";
import PersonalInventory from "./pages/personalInventory/PersonalInventory";
import Settings from "./pages/settings/Settings";
import DasEnde from "./pages/systemAdmin/DasEnde";
import RoutePage from "./pages/route/RoutePage";
import RouteRulesPage from "./pages/routeRules/RouteRulesPage";
import MessagesPage from "./pages/messages/MessagesPage";
import BlacklistPage from "./pages/blacklist/BlacklistPage";
import FootballPage from "./pages/football/FootballPage";
import OrdersPage from "./pages/orders/OrdersPage";
import NewOrdersPage from "./pages/orders/NewOrdersPage";
import SanctionssystemPage from "./pages/sanctionssystem/SanctionssystemPage";
import PriceListPage from "./pages/priceList/PriceListPage";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="profile" element={<Profile />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="personal-inventory" element={<ProtectedRoute requirePermission="personal_inventory.view"><PersonalInventory /></ProtectedRoute>} />
        <Route path="members" element={<ProtectedRoute requirePermission="members.view"><Members /></ProtectedRoute>} />
        <Route path="family-info" element={<ProtectedRoute requirePermission="familyinfo.view"><FamilyInfo /></ProtectedRoute>} />
        <Route path="warehouse-sync" element={<ProtectedRoute requirePermission="discord_sync.view"><WarehouseSync /></ProtectedRoute>} />
        <Route path="kassensystem" element={<ProtectedRoute requirePermission="kassensystem.view"><Kassensystem /></ProtectedRoute>} />
        <Route path="weekly-dues" element={<ProtectedRoute requirePermission="weeklydues.view"><WeeklyDues /></ProtectedRoute>} />
        <Route path="requests" element={<ProtectedRoute requirePermission="requests.manage"><AccessRequests /></ProtectedRoute>} />
        <Route path="users" element={<ProtectedRoute requirePermission="users.manage"><UsersHub /></ProtectedRoute>} />
        <Route path="activity" element={<ProtectedRoute requirePermission="activity.view"><UserActivity /></ProtectedRoute>} />
        <Route path="settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="das-ende" element={<ProtectedRoute requireSuperAdmin><DasEnde /></ProtectedRoute>} />
        <Route path="route" element={<ProtectedRoute requirePermission="route.view"><RoutePage /></ProtectedRoute>} />
        <Route path="route-rules" element={<ProtectedRoute requirePermission="routenregeln.view"><RouteRulesPage /></ProtectedRoute>} />
        <Route path="messages" element={<ProtectedRoute requirePermission="messages.manage"><MessagesPage /></ProtectedRoute>} />
        <Route path="blacklist" element={<ProtectedRoute requirePermission="blacklist.manage"><BlacklistPage /></ProtectedRoute>} />
        <Route path="football" element={<ProtectedRoute requirePermission="football.view"><FootballPage /></ProtectedRoute>} />
        <Route path="orders" element={<ProtectedRoute requirePermission="orders.create"><OrdersPage /></ProtectedRoute>} />
        <Route path="orders-open" element={<ProtectedRoute requirePermission="orders.manage"><NewOrdersPage /></ProtectedRoute>} />
        <Route path="sanctionssystem" element={<ProtectedRoute requirePermission="sanctionssystem.view"><SanctionssystemPage /></ProtectedRoute>} />
        <Route path="price-list" element={<ProtectedRoute requirePermission="price_list.view"><PriceListPage /></ProtectedRoute>} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
